import styles from './style.module.scss';
import { useReducer, useRef, useState } from 'react';
import { Tabs } from 'antd';
import { src } from '/utils/common';
import { WebPNativeImage } from '../../WebPImage';

const { TabPane } = Tabs;

const MobileTab = ({ useCaseData }) => {
  const [previous, setPrevious] = useState(0);
  const [current, setCurrent] = useState(0);
  return (
    <>
      {/* 移动端 */}
      <main className={styles['demo-mobile']}>
        <div className={styles['demo-title']}>{useCaseData.title}</div>
        <Tabs
          defaultActiveKey="0"
          onChange={(key) => {
            setPrevious(current);
            setCurrent(Number(key));
          }}
        >
          {useCaseData.items.map((item, index) => (
            <TabPane tab={item.title} key={index}>
              <div className={styles['wrapper']}>
                <WebPNativeImage
                  src={src(item.picUrl)}
                  alt="useCaseImg"
                  className={styles['demo-img']}
                />
                <div className={styles['sub-title']}>{item.subTitle}</div>
              </div>
            </TabPane>
          ))}
        </Tabs>
      </main>
    </>
  );
};

export default MobileTab;
